import Home from "./pages/Home";

function App() {
  //"react-router-dom": "^7.2.0",
  return (
    <>
      <Home />
    </>
  );
}

export default App;
